import React from 'react';
import PropTypes from 'prop-types';
import { cn } from 'lib/utils';

export default function ContentLibraryAssetCard({ asset, selected, onSelect }) {
  return (
    <li className='min-w-0'>
      <button
        type='button'
        onClick={onSelect}
        className={cn(
          'flex w-full flex-col overflow-hidden rounded-lg border text-left transition-shadow cursor-pointer p-0',
          selected
            ? 'border-primary-emphasis-light shadow-md ring-1 ring-primary-emphasis-light/30'
            : 'border-gray-200 hover:border-gray-300 hover:shadow-sm'
        )}
      >
        <div className='relative h-40 w-full shrink-0 overflow-hidden sm:h-44 flex justify-center items-center'>
          {asset.previewImgUrl ? (
            <img
              src={asset.previewImgUrl}
              alt=''
              className='h-full w-auto'
              loading='lazy'
            />
          ) : (
            <div className='flex h-full w-full items-center justify-center p-2 text-center text-xs text-gray-400'>
              No preview
            </div>
          )}
        </div>
        <div className='border-t border-gray-300 p-3'>
          <p className='m-0 line-clamp-2 text-sm font-bold text-gray-900'>
            {asset.name || 'Untitled'}
          </p>
          <p className='m-0 mt-1 line-clamp-2 text-xs italic text-gray-500'>
            {asset.type || '—'}
          </p>
        </div>
      </button>
    </li>
  );
}

const carrierShape = PropTypes.shape({
  name: PropTypes.string,
  id: PropTypes.string
});

const assetShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  type: PropTypes.string,
  name: PropTypes.string,
  carrier: carrierShape,
  categories: PropTypes.arrayOf(PropTypes.string),
  previewImgUrl: PropTypes.string,
  assetUrl: PropTypes.string,
  assetUrlType: PropTypes.string
});

ContentLibraryAssetCard.propTypes = {
  asset: assetShape.isRequired,
  selected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired
};
